
define('text!templates/parts/menu/menu-panel.html',[],function () { return '<button title="{{title}}" {{^type}}type="button" {{/type}}{{#type}}type="{{type}}" {{/type}} class="btn btn-link {{class}}">\n    {{#icon}}<span class="btn-icon {{icon}}"></span> {{/icon}}{{#name}}<span class="btn-text">{{#t}}{{name}}{{/t}}</span>{{/name}}\n</button>\n';});

